<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-card>
              <v-card-title class="pb-5">
                <!--                                    v-if="$can('transaction_create')"-->
                <v-btn to="/tariff" rounded color="#A5668B" class="text-white">
                  <v-icon>mdi-backspace-reverse-outline</v-icon>
                  بازگشت
                </v-btn>
                <v-spacer/>
                {{ $route.meta.title }}
                <v-spacer/>
                <v-btn @click="addTariff" color="#50858B" rounded class="text-white">
                  <v-icon>mdi-refresh</v-icon>
                  ذخیره
                </v-btn>
                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>


              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        :rules="rules.title"
                        v-model="title"
                        :error-messages="errors.title"
                        label="عنوان"
                        required
                        outlined
                        dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        :rules="rules.price"
                        v-model="price"
                        :error-messages="errors.price"
                        label="قیمت"
                        required
                        outlined
                        dense
                    >

                    </v-text-field>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        :rules="rules.expire"
                        v-model="expire_day"
                        :error-messages="errors.expire"

                        label="تاریخ انقضا"
                        outlined
                        dense
                    >

                    </v-text-field>
                  </v-flex>


                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                        v-model="show"
                        :items="shows"
                        item-text="name"
                        item-value="id"
                        label="وضعیت نمایش"
                        :error-messages="errors.show"
                        outlined
                        dense
                        return-object
                    ></v-select>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                        v-model="can_divert"
                        :items="diverts"
                        item-text="value"
                        item-value="id"
                        label="قابل انتقال"
                        :error-messages="errors.can_divert"
                        outlined
                        dense
                        return-object
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                        v-model="is_fluent"
                        :items="fluents"
                        :error-messages="errors.fluent_id"
                        item-text="value"
                        item-value="id"
                        label="رند"
                        outlined
                        dense
                        return-object
                    ></v-select>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                        v-model="is_recursive"
                        :items="recursives"
                        item-text="value"
                        :error-messages="errors.is_recursive"
                        item-value="id"
                        label="نوع خط"
                        outlined
                        dense
                        return-object
                    ></v-select>

                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        :rules="rules.count"
                        v-model="count"
                        :error-messages="errors.count"

                        label="تعداد خط"
                        outlined
                        dense>
                    </v-text-field>
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import {SET_BREADCRUMB} from "../../../../core/services/store/breadcrumbs.module";

export default {
  data() {
    return {
      diverts: [
        {id: 1, value: 'دارد'},
        {id: 0, value: 'ندارد'},
      ],
      can_divert: null,
      fluents: [
        {id: 1, value: 'دارد'},
        {id: 0, value: 'ندارد'},
      ],
      is_fluent: null,
      recursives: [
        {id: 1, value: 'بازگشتی '},
        {id: 0, value: 'غیر بازگشتی'},
      ],
      is_recursive: null,
      title: null,
      price: null,
      expire_day: null,
      count: null,
      show: {id: null},
      shows: [
        {id: 1, name: 'فعال'},
        {id: 0, name: 'غیر فعال'}
      ],
      errors: [],
      rules: {
        title: [val => (val || '').length > 0 || 'فیلد عنوان الزامی می باشد.'],
        price: [val => (val || '').length > 0 || 'فیلد قیمت الزامی می باشد.'],
        count: [val => (val || '').length > 0 || 'فیلد تعداد الزامی می باشد.'],
      },

    }
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}]);
  },

  methods: {

    addTariff() {
      this.requestApiPost('tariff', {
        title: this.title,
        price: this.price,
        expire_day: this.expire_day,
        show: this.show.id,
        can_divert: this.can_divert.id,
        count: this.count,
        is_fluent: this.is_fluent.id,
        is_recursive: this.is_recursive.id,
      }).then(response => {
        this.$toast.success('بسته جدید با موفقیت ایجاد شد.');
        this.$router.push({name: 'tariff.index'});
      }).catch(({response}) => {
        this.errors = response;
      });

    },

  },

}
</script>
